import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/data-purge/runs')({
  beforeLoad: () => getTitleContextSlice('Runs'),
  staticData: {
    owner: CodeOwner.DataFabric,
  },
});
